/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AdBlocker from 'cio/services/ad-blocker';
import {
  Facebook as FacebookNetwork,
  Adwords as AdwordsNetwork,
} from 'cio/components/segments/create-audience/select-network';

interface FacebookArgs {
  isSelected?: boolean;
  network: FacebookNetwork | AdwordsNetwork;
  adAccountId: string | null;
  onConnect: (event: Event) => unknown;
}

export default class Facebook extends Component<FacebookArgs> {
  @service adBlocker!: AdBlocker;

  constructor(owner: unknown, args: FacebookArgs) {
    super(owner, args);

    this.adBlocker.checkFacebook.perform();
  }

  get isSelected() {
    return this.args.isSelected ?? false;
  }
}
